import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useLabelOutput, usePackingSlipFormat } from '../../../hooks/use-seller-setting';
import { DocumentType } from '../../../enums/document-type';
import { DocumentTypePropType } from '../../../prop-types/document-type';
import { useEnableNewLayoutOptions } from '../../../feature-flags/hooks/use-enable-new-layout-options';

import { findMatchingSettingEnum } from './document-option-modal/helpers';
import { useSellerLabelFormats } from './document-option-modal/hooks/use-seller-label-formats';

import {
  defaultPackingSlipFormats,
  newPackingSlipFormats,
  INCLUDES_PACKING_SLIP_SUFFIX,
} from './document-option-modal/packing-slip/constants';
import messages from './messages';

const DocumentFormatColumn = ({ docType }) => {
  const labelFormat = useLabelOutput();
  const labelFormats = useSellerLabelFormats();
  const labelFormatDisplay = findMatchingSettingEnum(labelFormats, labelFormat);
  const packingSlipFormat = usePackingSlipFormat();

  // TODO: [SPD-19601]: Remove this logic when feature flag is removed
  const enableNewLayoutOptions = useEnableNewLayoutOptions();
  const packingSlipFormats = useMemo(
    () => (enableNewLayoutOptions ? [...defaultPackingSlipFormats, ...newPackingSlipFormats] : defaultPackingSlipFormats),
    [enableNewLayoutOptions],
  );

  const packingSlipFormatDisplay = findMatchingSettingEnum(packingSlipFormats, packingSlipFormat);
  if (docType === DocumentType.Label.identifier || docType === DocumentType.ReturnLabel.identifier) {
    return labelFormatDisplay.isCustom ? (
      <FormattedMessage {...messages.custom} />
    ) : (
      <FormattedMessage {...labelFormatDisplay.messageDescriptor} />
    );
  }
  if (docType === DocumentType.PackingSlip.identifier) {
    if (labelFormat.includes(INCLUDES_PACKING_SLIP_SUFFIX)) {
      return <FormattedMessage {...messages.includedWithLabels} />;
    }
    return <FormattedMessage {...packingSlipFormatDisplay.messageDescriptor} />;
  }
  return <FormattedMessage {...messages.defaultDocumentFormat} />;
};

DocumentFormatColumn.propTypes = {
  docType: DocumentTypePropType.isRequired,
};

export default DocumentFormatColumn;
